import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const VideoTranslations = wrapTranslationsSchema({
	name: 'VideoTranslations',
	title: 'Video Translations',
	sanityId: 'video',
	fields: {
		playVideo: 'Play video',
		videoUrlNotProvided: 'Video URL is not provided',
		videoUrlNotSupported: 'Video URL is not supported',
	},
});
